module.exports = __webpack_public_path__ + "static/media/user-pin-danger.62939e73.svg";